import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

function MegaMenu({ isOpen = false, menuContent, onMouseEnter, onMouseLeave, anchorRef }) {
  const menuRef = useRef(null);
  const [arrowLeft, setArrowLeft] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) return;
    const handleKey = e => { if (e.key === "Escape" && onMouseLeave) onMouseLeave(); };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [isOpen, onMouseLeave]);

  useEffect(() => {
    if (isOpen && anchorRef?.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      setArrowLeft(center - 8);
    } else {
      setArrowLeft(null);
    }
  }, [isOpen, anchorRef]);

  useEffect(() => {
    const handleResize = () => {
      if (isOpen && anchorRef?.current) {
        const rect = anchorRef.current.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        setArrowLeft(center - 8);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen, anchorRef]);

  if (!menuContent) return null;

  const renderDesktop = () => {
    if (menuContent.type === "products" || menuContent.type === "solutions") {
      const isSolutions = menuContent.type === "solutions";
      const itemCount = menuContent.categories.length;
      const colClass = isSolutions ? "grid-cols-4" : `grid-cols-${itemCount}`;
      return (
        <div className="flex justify-center z-[99]">
          <div className={`grid ${colClass} gap-6 px-6 py-10 max-w-fit mx-auto`}>
            {menuContent.categories.map((category, index) => (
              <button
                key={index}
                type="button"
                onClick={() => category.link && navigate(category.link)}
                className="flex flex-col items-center text-center mb-3 px-6 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded transition-colors hover:bg-gray-50"
                aria-label={category.name}
              >
                {category.image && (
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-32 h-32 object-cover mb-2 pointer-events-none rounded"
                    draggable="false"
                  />
                )}
                <h3 className="text-sm font-semibold text-gray-800">{category.name}</h3>
                {category.link && (
                  <span className="mt-1 text-[11px] text-blue-600">前往</span>
                )}
              </button>
            ))}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      ref={menuRef}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      aria-hidden={!isOpen}
      className={`hidden md:block fixed left-0 top-[64px] w-full bg-white shadow-lg border-t border-gray-200 z-50 transition-opacity duration-150 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      {isOpen && arrowLeft !== null && (
        <span
          style={{
            position: 'absolute',
            top: '-8px',
            left: `${arrowLeft}px`,
            width: 0,
            height: 0,
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderBottom: '8px solid white',
            filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.25))',
            transition: 'left 120ms ease'
          }}
          aria-hidden="true"
        />
      )}
      {renderDesktop()}
    </div>
  );
}

export default MegaMenu;